import request from 'request';
import { DataSourceResource, EnrolmentResource, ListResource } from 'services/resources';

const BASE_URL = 'tsd-telematics/';

const URLs = {
  dataSources: `${BASE_URL}data-sources/`,
  enrolments: `${BASE_URL}enrollments/`,
} as const;

/**
 * Returns a list of data sources
 */
export function getDataSources() {
  return request<ListResource<DataSourceResource>>(URLs.dataSources, {
    method: 'GET',
  });
}

/**
 * Returns a list of enrolments
 */
export function getEnrolments() {
  return request<ListResource<EnrolmentResource>>(URLs.enrolments, {
    method: 'GET',
  });
}

/**
 * Updates an enrolment
 */
export function patchEnrolment(enrolmentId: number, data: Partial<EnrolmentResource>) {
  return request<EnrolmentResource>(`${URLs.enrolments}${enrolmentId}/`, {
    method: 'PATCH',
    data: data,
  });
}

/**
 * Deletes an enrolment
 */
export function deleteEnrolment(enrolmentId: number) {
  return request<EnrolmentResource>(`${URLs.enrolments}${enrolmentId}/`, {
    method: 'DELETE',
  });
}

/**
 * Enrolls a vehicle
 */
export function postEnrollment(vehicleId: number) {
  return request<EnrolmentResource>(URLs.enrolments, {
    method: 'POST',
    data: { vehicleId },
  });
}
